// extracted by mini-css-extract-plugin
export default {"primary-font":"Account_primary-font__wjue9","secondary-font":"Account_secondary-font__16oo2","virtual-code":"Account_virtual-code__Msp0t","orangeLink":"Account_orangeLink__yvBuF"};